module.exports = __webpack_public_path__ + "static/media/icon-medicare-app.564e033f.png";